import NavBar from './components/NavBar/NavBar';
import Profile from './components/Profile/Profile';
import Projects from './components/Projects/Projects';
import Skills from "./components/Skills/Skills";
import Experience from "./components/Experience/Experience";
import Footer from './components/Footer/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <NavBar />
      <Profile />
      <Skills />
      <Projects />
      <Experience />
      <Footer />
    </div>
  );
}

export default App;
